import React from "react";
import { useQuickSightHealthEvents } from "@/hooks/useHealthEvents";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsHealthDashboard from "@/components/organisms/HealthEventsDashboard";

function HealthEventsReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightHealthEvents();

  return (
    <AWSReportsTemplate
      title="AWS Health Events Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsHealthDashboard />
    </AWSReportsTemplate>
  );
}

export default HealthEventsReports;
